import React from "react";

import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <Weather defaultCity="New York" />
        </header>

        <footer>
          Coded by {""}
          <a
            href="https://www.linkedin.com/in/emmanuellabraide/"
            target="_blank"
            rel="noreferrer"
            className="ella"
          >
            Ella Braide {""}
          </a>
          - Open-sourced {""}
          <a
            href="https://github.com/Missbraide/my-app"
            target="_blank"
            rel="noreferrer"
            className="git"
          >
            on GitHub{" "}
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
